// 返回浏览器语言
export const getSysLang = () => {
    const type = window.navigator.appName
    let lang = ''
    if (type === 'Netscape') {
        lang = window.navigator.language
    } else {
        lang = window.navigator.userLanguage
    }
    return lang.substr(0, 2)
}

// 获取值类型
export const getType = target => {
    var type = Object.prototype.toString.call(target)
    //根据空格切分
    var list = type.split(/[ ]/)
    //获取第二个字符串，然后再进行以“]”分隔符切分
    var newType = list[1].split(']')
    //获取第一个字符串
    // console.log(newType[0])
    return newType[0]
}
